import * as Localization from "expo-localization";

export type Region = "US" | "FR" | "UK";

/** Return the device's exact ISO country code when the platform provides it. */
export function useCountryCode(): string | null {
  try {
    return Localization.getLocales()[0]?.regionCode?.toUpperCase() ?? null;
  } catch {
    return null;
  }
}

/**
 * The user's region — drives feature availability (the US-only cost tools) and
 * region-specific content.
 *
 * Region follows the device's LOCATION/country (`regionCode`), NOT the app
 * language. Language and country are independent: a French-speaking patient
 * located in the US should still get the US experience, and an English speaker
 * located in France should be gated to the FR experience. Expo also recommends
 * `regionCode` (not the language code) for exactly this.
 *
 * Mapping: US → US, GB → UK, any other country → FR (the non-US bucket the cost
 * screens gate against). When the region can't be determined, default to US so
 * a detection failure doesn't lock users out of features.
 */
export function useRegion(): Region {
  const regionCode = useCountryCode();

  if (!regionCode) return "US";
  if (regionCode === "US") return "US";
  if (regionCode === "GB") return "UK";
  return "FR";
}
